import type { PreferenceBlockedReason } from "../services/accountService";

/**
 * Renewal-preference error code → Polish message mapper (AC-5/AC-15).
 * Mirrors `apps/frontend/src/components/admin/tenant-deletion/error-code-mapper.ts`.
 */
const ERROR_CODE_MESSAGES: Record<PreferenceBlockedReason, string> = {
  SCHEDULED_SUCCESSOR_EXISTS:
    "Kolejny okres jest już opłacony — zmiana pakietu nie jest już możliwa.",
  RENEWAL_PAYMENT_RECEIVED:
    "Otrzymaliśmy już wpłatę za kolejny okres. Skontaktuj się z nami, aby zmienić pakiet.",
  MANUAL_ORDER_OPEN: "Zmianę pakietu obsługuje nasz zespół. Skontaktuj się z nami.",
  NOT_ACTIVE: "Zmiana pakietu jest dostępna tylko dla aktywnej subskrypcji.",
  AUTO_RENEWAL_DISABLED: "Włącz automatyczne odnawianie, aby wybrać pakiet na kolejny okres.",
};

const DEFAULT_FALLBACK = "Nie udało się zapisać zmiany. Spróbuj ponownie.";

export function mapRenewalPreferenceErrorCode(
  code: PreferenceBlockedReason | string | undefined | null
): string {
  if (!code) return DEFAULT_FALLBACK;
  return ERROR_CODE_MESSAGES[code as PreferenceBlockedReason] ?? DEFAULT_FALLBACK;
}
